export const Landing = () => {
  return <div>Landing</div>;
};

export default Landing;
